/**
 * Global styles should be imported before any other Vue files
 */
import 'normalize.css';
import '@/assets/css/app.scss';
import '@/assets/css/motion.scss';

/**
 * Entry vue
 */
import 'babel-polyfill';
import 'intersection-observer';
import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
import { sync } from 'vuex-router-sync';
import router from '@/routers'; // Must be a name as `router`
import store from '@/store'; // Must be a name as `store`

/**
 * Plugin
 */
import plugins from '@/shared/plugins';
import vueHead from 'vue-head';
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import VueFilterDateFormat from 'vue-filter-date-format';
//import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag';
import SocialSharing from 'vue-social-sharing';
import VueClipboard from 'vue-clipboard2';
import { ObserveVisibility } from 'vue-observe-visibility';

/**
 * Install pluginsxcx
 */
Vue.config.devtools = true;
Vue.use(plugins);
Vue.use(vueHead);
Vue.$cookies = VueCookies;
Vue.prototype.$cookies = VueCookies;
Vue.use(VueFilterDateFormat);
Vue.config.productionTip = false;
sync(store, router);
Vue.use(VueI18n);
Vue.use(SocialSharing);
Vue.use(VueClipboard);
Vue.use(
  VueGtag,
  {
    config: {
      id: `G-HB3R0DC56Y`,
      params: {
        send_page_view: false
      }
    }
  },
  router
);
Vue.directive('observe-visibility', ObserveVisibility);
/* Vue.use(VueGtm, {
  id: 'GTM-PXX777',
  vueRouter: router
}) */

const lang = Vue.$cookies.get('lang') ? Vue.$cookies.get('lang') : 'ko';
const i18n = new VueI18n({
  locale: lang,
  messages: {
    ko: require('@/assets/json/locales/ko.json'),
    en: require('@/assets/json/locales/en.json')
  }
});
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
